const isMagentoStoreActive = () => {
  return process.env.GATSBY_MAGENTO_STORE_ACTIVE === "true"
}

module.exports = {
  isMagentoStoreActive,
}
